import React from 'react';
import styled from 'styled-components/macro';
import { HashLink as Link } from 'react-router-hash-link';
import Icon from './images/icon-arrow.svg';

const Wrapper = styled(Link)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.67;
  color: #777777 !important;
  text-decoration: none;
`;

export const LinkItem = props => (
  <Wrapper to={props.to}>
    <span>{props.children}</span>
    <span>
      <img src={Icon} alt="" />
    </span>
  </Wrapper>
);

const Container = styled.div`
  max-width: 440px;
  margin-bottom: 80px;

  a {
    border-top: 1px solid #ebebeb;

    :first-child {
      border-top: 0;
    }
  }
`;

const QuickLinks = props => <Container>{props.children}</Container>;

export default QuickLinks;
